// src/pages/grupos/MeusGrupos.jsx
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import api from "../../services/api";
import BotaoVoltar from "../../components/BotaoVoltar";

export default function MeusGrupos() {
  const [grupos, setGrupos] = useState([]);
  const [convites, setConvites] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const r1 = await api.get("/grupos/");
      const r2 = await api.get("/grupos/convites/");
      setGrupos(r1.data);
      setConvites(r2.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="fw-bold">Meus Grupos</h2>
          <BotaoVoltar to="/dashboard" />
        </div>

        <div className="text-end mb-3">
          <Link
            to="/grupos/convites"
            className="btn btn-outline-secondary btn-sm me-2"
          >
            Convites ({convites.length})
          </Link>

          <Link to="/grupos/novo" className="btn btn-primary btn-sm">
            + Criar Grupo
          </Link>
        </div>

        {loading && <p>Carregando...</p>}

        {!loading && grupos.length === 0 && <p>Nenhum grupo encontrado.</p>}

        <div className="list-group">
          {grupos.map((g) => (
            <Link
              to={`/grupos/${g.id}`}
              key={g.id}
              className="list-group-item list-group-item-action d-flex align-items-center"
            >
              <img
                src={g.imagem_capa || "/grupo-default.png"}
                width={55}
                height={55}
                className="rounded-circle me-3"
                alt={g.nome}
                style={{ objectFit: "cover" }}
              />

              <div>
                <strong className="d-block">{g.nome}</strong>
                <span className="text-muted small">
                  {g.membros_ativos} membros ativos
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
